import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { apiFetch } from '../../../utils/auth/apiFetch';
import { SCREENMAKER_DATA, SCREENMAKER_START, SCREENMAKER_END } from "../type";

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

interface ScreenMakerParams {
  page?: number;
  size?: number;
}

type Dispatch = (action: Action) => void;

export const getScreenMaker = (params: ScreenMakerParams = {}) => async (dispatch: Dispatch): Promise<void> => {
  if (!validateToken()) { redirectToLogin(); return; }

  dispatch({ type: SCREENMAKER_START, payload: true, loading: true });

  const page = params.page ?? 0;
  const size = params.size ?? 9;

  const result = await apiFetch(`/file/get-unapproved-files/${page}/${size}`);
  if (!result) return; // 1101 - redirected

  if (result.ok) {
    dispatch({ type: SCREENMAKER_DATA, payload: [{ res: result.data }], loading: false });
  } else {
    dispatch({ type: SCREENMAKER_END, payload: [{ res: result.data }], loading: false });
  }
};

export const getTransactionsByFile = (fileId: number, page: number, size: number) => async (dispatch: Dispatch): Promise<void> => {
  if (!validateToken()) { redirectToLogin(); return; }

  const result = await apiFetch(`/file/get-trx-by-file/${fileId}/${page}/${size}`);
  if (!result) return;

  if (result.ok) return result.data;
};
